import { RootState } from "../reducers"

export const selectHasAccess = (state: RootState) => state.ui.hasAccess

export const selectCanSendTransactions = (state: RootState) =>
  state.ui.canSendTransactions

export const selectNotification = (state: RootState) => state.ui.notification

export const selectOpenModal = (state: RootState) => state.ui.openModal

export const selectModalOptions = (state: RootState) => state.ui.modalOptions

export const selectModalOpenedAt = (state: RootState) => state.ui.modalOpenedAt

export const selectPartner = (state: RootState) => state.ui.partner

export const selectHasLoadedPartnerData = (state: RootState) =>
  state.ui.hasLoadedPartnerData

export const selectHasLoadedAccountData = (state: RootState) =>
  state.ui.hasLoadedAccountData
